import { FormattedMessage } from "react-intl";

import { formatTime } from "src/utils/breakReason";

import { Box, Typography } from "@mui/material";

import {
	BreakReasonName,
	EndBreakPageButton,
	InfoText,
	LimitTimeDisplay,
	PageContainer,
	PageIcon,
	PageTimeDisplay,
	StatusLabel,
	TimeWrapper,
	InfoTextContainer
} from "./styles";

import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';


const BreakReasonTimerPage = ({
	status,
	breakreasonactive,
	elapsedTime,
	breaklimit,
	exceededTime,
	handleOpenEndBreakDialog,
	intl,
	disableTimeout,
	disableExtendedTime,
	...props
}) => {

	return (
		<PageContainer status={status} backgroundColorPage={props?.backgroundColorPage}>
			<PageIcon status={status}>
				<PauseCircleOutlineIcon />
			</PageIcon>

			<BreakReasonName status={status}>
				{breakreasonactive?.reasonbreak?.name || intl.formatMessage({ id: "break.reason.time.paused" })}
			</BreakReasonName>

			<StatusLabel status={status}>
				{status === 'exceeded' && !disableExtendedTime
					? intl.formatMessage({ id: "break.reason.time.exceeded" })
					: intl.formatMessage({ id: "break.reason.time.paused" })}
			</StatusLabel>

			<TimeWrapper>
				<PageTimeDisplay status={status}>
					{formatTime(elapsedTime)}
				</PageTimeDisplay>

				{!disableTimeout && (
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '16px' }}>
						<AccessTimeIcon
							sx={{
								marginRight: '6px'
							}}
						/>

						<LimitTimeDisplay status={status}>
							<FormattedMessage id="break.reason.limit" values={{ limit: breaklimit }} />
						</LimitTimeDisplay>
					</Box>
				)}
			</TimeWrapper>

			<EndBreakPageButton
				status={status}
				variant="contained"
				startIcon={<PauseCircleOutlineIcon />}
				onClick={handleOpenEndBreakDialog}
			>
				<FormattedMessage id="break.reason.time.end" />
			</EndBreakPageButton>

			{!disableExtendedTime && (
				<InfoTextContainer>
					{status === 'exceeded' && (
						<Typography variant="subtitle2" fontWeight={"600"} color={'rgba(0, 0, 0, 0.6)'}>
							<FormattedMessage id="break.reason.time.exceeded.info" values={{ exceededTime }} />
						</Typography>
					)}

					{status === 'warning' && (
						<Typography variant="subtitle2" fontWeight={"600"} color={'rgba(0, 0, 0, 0.6)'}>
							<FormattedMessage id="break.reason.time.limit.warning" />
						</Typography>
					)}
				</InfoTextContainer>
			)}
		</PageContainer>
	);
};

export default BreakReasonTimerPage;